import { TextField, Paper, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Box, Button, Switch, IconButton } from "@mui/material";
import Wrapper from "../components/Wrapper";
import { useEffect, useState } from "react";
import AdminFormDrawer from "../components/AdminFormDrawer";
import { listAdmin, updateAdmin } from "../services/admin";
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import { Edit, Key } from "@mui/icons-material";
import AdminPasswordModal from "../components/AdminPasswordModal";
import { Link } from "react-router-dom";

const Home = () => {

  const [admin_drawer_open, set_admin_drawer_open] = useState(false);
  const [admin_users, set_admin_users] = useState([]);
  const [page, set_page] = useState(0);
  const [count, set_count] = useState(0);
  const [search, set_search] = useState('');
  const [show_password_dialog, set_show_password_dialog] = useState(false);
  const [selected_user_id, set_selected_user_id] = useState('');

  const getData = async () => {
    const {data} = await listAdmin({
      page : page,
      limit : 10,
      search : search
    })

    if(data){
      set_admin_users(data.data);
      set_count(data.total_records);
    }
  }

  const handleChangePage = (event, page_no) => {
    set_page(page_no)
  }

  useEffect(() => {
    getData();

    // eslint-disable-next-line
  }, [page, search])

  const handleChangeActiveStatus = async (status, id) => {
    const {data, error} = await updateAdmin({
      data : {
        active : status
      },
      id : id
    });

    if(data){
      enqueueSnackbar('Status updated successfully', {
        variant : 'success'
      })
      getData();
    }
    if(error){
      enqueueSnackbar('Error while updating status', {
        variant : 'error'
      })
    }
  }

  const handleClickUpdatePassword = (admin_id) => {
    set_selected_user_id(admin_id);
    set_show_password_dialog(true);
  }

  const handleClosePasswordDialog = () => {
    set_selected_user_id('');
    set_show_password_dialog(false);
  }

  return(
    <Wrapper>
      <Box
        component='div'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <TextField
          label = 'Search'
          sx={{
            width : '450px'
          }}
          value={search}
          onChange={(e) => set_search(e.target.value)}
        />

        <Box component='div'>
          <Button
            variant="contained"
            onClick={() => set_admin_drawer_open(true)}
          >
            Add New
          </Button>
        </Box>
      </Box>

      <Paper
        elevation={4}
        sx={{
          marginTop : '20px'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Sr No.
              </TableCell>
              <TableCell>
                Name
              </TableCell>
              <TableCell>
                Email
              </TableCell>
              <TableCell>
                Contact Number
              </TableCell>
              <TableCell>
                Status
              </TableCell>
              <TableCell>
                Created At
              </TableCell>
              <TableCell>
                Update Password
              </TableCell>
              <TableCell>
                Edit Profile
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {
              admin_users.map((admin_user, ind) => {
                return(
                  <TableRow key={admin_user._id}>
                    <TableCell>
                      {ind + 1}
                    </TableCell>
                    <TableCell>
                      {admin_user.name}
                    </TableCell>
                    <TableCell>
                      {admin_user.email}
                    </TableCell>
                    <TableCell>
                      {admin_user.contact_number}
                    </TableCell>
                    <TableCell>
                      <Switch
                        checked = {admin_user.active}
                        onChange={(e) => handleChangeActiveStatus(e.target.checked, admin_user._id)}
                      />
                    </TableCell>
                    <TableCell>
                      {moment(admin_user.created_at).format('DD-MM-YYYY hh:mm A')}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => handleClickUpdatePassword(admin_user._id)}
                      >
                        <Key />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <Link
                        to={`/edit-profile/${admin_user._id}`}
                      >
                        <IconButton>
                          <Edit />
                        </IconButton>
                      </Link>
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={count}
          page={page}
          rowsPerPage={10}
          rowsPerPageOptions={[]}
          onPageChange={handleChangePage}
        />
      </Paper>
      
      <AdminFormDrawer
        open={admin_drawer_open}
        handleClose={() => set_admin_drawer_open(false)}
        getData = {getData}
      />

      <AdminPasswordModal
        open={show_password_dialog}
        admin_id={selected_user_id}
        onClose={handleClosePasswordDialog}
      />
    </Wrapper>
  )
}

export default Home;